export default {
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.user.login.title': '合伙人管理平台登录',
  'pages.user.login.subTitle': '安全、高效的金融交易体验',
  'pages.user.login.securityTips': '您的账户安全是我们的首要任务。所有交易都经过SSL加密保护。',
  'pages.user.login.copyright': '© 2025 交易平台. 保留所有权利.',
  'pages.user.login.placeholderEmail': '请输入手机/邮箱账号',
  'pages.user.login.placeholderPassword': '请输入密码',
  'pages.user.login.placeholderCaptcha': '请输入验证码',
  'pages.user.login.loginButton': '登录',
  'pages.user.login.loginLoading': '登录中...',
  'pages.user.login.getEmailCode': '获取邮箱验证码',
  'pages.user.login.getCaptcha': '获取验证码',
  'pages.user.login.getGoogleCode': '获取谷歌验证码',
  'pages.user.login.description': '安全、高效的金融交易体验',
  'pages.user.login.emailAddress': '手机号/邮箱',
  'pages.user.login.countryChina': '中国',
  'pages.user.login.password': '密码',
  'pages.user.initPassword.title': '修改密码',
  'pages.user.initPassword.welcome': '欢迎您：{userName}-{email}',
  'pages.user.initPassword.description': '由于您首次登录，为了您的账户安全，请您修改密码，修改后请重新登录。',
  'pages.user.initPassword.newPassword': '新密码',
  'pages.user.initPassword.confirmPassword': '确认密码',
  'pages.user.initPassword.submit': '提交',
  'pages.user.initPassword.oldPassword': '旧密码',
  'pages.user.initPassword.oldPasswordRequired': '请输入旧密码',
  'pages.user.initPassword.oldPasswordPlaceholder': '请输入旧密码',
  'pages.user.initPassword.newPasswordRequired': '请输入新密码',
  'pages.user.initPassword.passwordMinLength': '密码长度至少8位',
  'pages.user.initPassword.passwordMismatch': '新密码与确认密码不一致',
  'pages.user.initPassword.confirmPasswordPlaceholder': '请输入确认密码',
  'pages.user.initPassword.confirmPasswordRequired': '请输入确认密码',
  'pages.user.initPassword.newPasswordPlaceholder': '请输入新密码',
  'pages.common.status': '状态',
  'pages.common.createTime': '创建时间',
  'pages.common.option': '操作',
  'pages.common.orderNum': '排序',
  'pages.common.keywordSearch': '关键词',
  'pages.common.serialNumber': '序号',
  'pages.common.remark': '备注',
  'pages.common.updateRemark': '更新备注',
  'pages.common.inviteCodeCustomize': '邀请码（自定义）',
  'pages.common.inviteCode': '邀请码',
  'pages.common.inviteLink': '邀请链接',
  'pages.common.settlementTime': '结算时间',
  'pages.common.statisticsTimeTooltip': '实时统计每一笔佣金收入，每天上午6点发放前一天的佣金数量',
  'pages.common.statisticsTimeTooltip2': '每天上午6点发放前一天的佣金数量',
  'pages.common.equivalentUSDT': '折合USDT',
  'pages.common.specifiedSubordinateUID': '下级团队UID',
  'pages.common.pleaseEnterUID': '请输入UID查询其伞下团队',
  'pages.common.pleaseEnterUIDDescription': '输入任意下级成员的 UID，系统将以该用户为起点，展示其伞下用户数据',
  'pages.team.teamLeaderQueryDirectOnly': '仅下一级',
  'pages.team.teamLeaderQueryAllUnder': '伞下所有',
  'pages.common.systemDefault': '系统默认',
  'pages.system.user.loginAccount': '登录账号',
  'pages.system.user.userName': '用户名称',
  'pages.system.user.nickName': '用户昵称',
  'pages.system.user.role': '所属角色',
  'pages.system.user.email': '邮箱',
  'pages.system.user.phone': '手机号',
  'pages.system.user.password': '密码',
  'pages.system.user.addUser': '新增用户',
  'pages.system.user.editUser': '编辑用户',
  'pages.system.user.resetPassword': '重置密码',
  'pages.system.user.assignRole': '分配角色',
  'pages.system.user.confirmPassword': '确认密码',
  'pages.system.user.emailInvalid': '请输入正确的邮箱地址',
  'pages.system.user.uidInvalid': '请输入正确的UID',
  'pages.system.user.phoneInvalid': '请输入正确的手机号',
  'pages.system.user.passwordInvalid': '密码长度不少于8位，至少包含三种：大小写字母、数字、特殊符号',
  'pages.system.user.userNameLength': '用户名称长度为2-20位',
  'pages.system.role.roleName': '角色名称',
  'pages.system.role.roleKey': '权限字符',
  'pages.system.role.admin': '是否管理员',
  'pages.system.role.roleSort': '排序',
  'pages.system.role.menuPermission': '菜单权限',
  'pages.system.role.dataScope': '数据范围',
  'pages.system.role.allDataScope': '全部数据权限',
  'pages.system.role.customDataScope': '自定数据权限',
  'pages.system.role.deptDataScope': '本部门数据权限',
  'pages.system.role.deptAndBelowDataScope': '本部门及以下数据权限',
  'pages.system.role.onlySelfDataScope': '仅本人数据权限',
  'pages.system.role.dataPermission': '数据权限',
  'pages.system.role.addRole': '新增角色',
  'pages.system.role.editRole': '编辑角色',
  'pages.system.role.roleKeyInvalid': '请输入大小写字母组成的权限字符',
  'pages.system.menu.menuName': '菜单名称',
  'pages.system.menu.perms': '权限标识',
  'pages.system.menu.menuType': '菜单类型',
  'pages.system.menu.topMenu': '顶级菜单',
  'pages.system.menu.parentMenu': '上级菜单',
  'pages.system.menu.addMenu': '新增菜单',
  'pages.system.menu.editMenu': '编辑菜单',
  'pages.system.dept.deptName': '部门名称',
  'pages.system.dept.topDept': '顶级部门',
  'pages.system.dept.addDept': '新增部门',
  'pages.system.dept.editDept': '编辑部门',
  'pages.system.dept.parentDept': '上级部门',
  'pages.system.dept.leader': '负责人',
  'pages.system.dept.phone': '联系电话',
  'pages.system.dept.email': '邮箱',
  'pages.system.permissions.bdList': 'BD 列表',
  'pages.system.permissions.partnerList': '合伙人列表',
  'pages.system.permissions.searchBd': '搜索BD名称...',
  'pages.system.permissions.partnerLevel': '合伙人层级',
  'pages.system.permissions.partnerLevelDescription': '请选择一个BD查看合伙人层级',
  'pages.system.permissions.noPartner': '该BD暂无合伙人数据',
  'pages.system.permissions.noBd': '暂无BD数据',
  'pages.system.permissions.confirmTransfer': '确认转移',
  'pages.system.permissions.confirmTransferDescription':
    '确定要将该节点以及节点下的数据进行转移吗？（并继承上下级邀请关系）',
  'pages.system.permissions.confirmTransferDescription2':
    '注意：拖拽节点的返佣比例大于新节点的返佣比例，请前往修改新节点的返佣比例等于或大于拖拽节点比例，否则将无法返佣。',
  'pages.system.permissions.transferNode': '转移节点',
  'pages.system.permissions.targetBd': '目标BD',
  'pages.system.permissions.targetNode': '目标节点',
  'pages.system.permissions.toRootLevel': '设置为最高一级',
  'pages.account.settings.base': '基本信息',
  'pages.account.settings.binding': '谷歌绑定',
  'pages.account.settings.password': '修改密码',
  'pages.account.settings.googleBind': '谷歌验证器绑定',
  'pages.account.settings.googleUnbind': '谷歌验证器解绑',
  'pages.account.settings.googleBindDescription':
    '绑定谷歌验证器可以为您的账户提供额外的安全保护。每次登录时都需要输入动态验证码。',
  'pages.account.settings.googleBindSuccess': '谷歌验证器已绑定',
  'pages.account.settings.googleBindSuccessDescription': '您的账户已成功绑定谷歌验证器，登录时将需要输入动态验证码。',
  'pages.account.settings.googleBindStep1': '1. 在手机上安装 Google Authenticator 应用',
  'pages.account.settings.googleBindStep2': '2. 打开应用，点击"+"号',
  'pages.account.settings.googleBindStep3': '3. 选择"扫描条形码"或"手动输入密钥"',
  'pages.account.settings.googleBindStep4': '4. 扫描上方二维码或输入密钥',
  'pages.account.settings.googleBindStep5': '手动输入密钥：',
  'pages.account.settings.emailVerificationCode': '邮箱验证码',
  'pages.account.settings.pleaseEnterEmailVerificationCode': '请输入邮箱验证码',
  'pages.account.settings.getVerificationCode': '获取验证码',
  'pages.account.settings.secondsLater': '秒后重新获取',
  'pages.account.settings.googleVerificationCode': '谷歌验证码',
  'pages.account.settings.pleaseEnterGoogleVerificationCode': '请输入谷歌验证器中的6位验证码',
  'pages.account.settings.pleaseEnter6DigitVerificationCode': '请输入6位数字验证码',
  'pages.account.settings.googleBindNot': '未绑定谷歌验证器',
  'pages.account.settings.scanGoogleAuthenticator': '步骤1：扫描二维码',
  'pages.account.settings.bindGoogleAuthenticator': '步骤2：验证绑定',
  'pages.account.settings.userId': '用户ID',
  'pages.account.settings.loginAccount': '登录账号',
  'pages.account.settings.userNickname': '用户昵称',
  'pages.account.settings.gender': '性别',
  'pages.account.settings.male': '男',
  'pages.account.settings.female': '女',
  'pages.account.settings.unknown': '未知',
  'pages.account.settings.department': '部门',
  'pages.account.settings.notAssigned': '未分配',
  'pages.account.settings.notSet': '未设置',
  'pages.account.settings.createTime': '创建时间',
  'pages.account.settings.rolePermission': '角色权限',
  'pages.account.settings.roles': '所属角色',
  'pages.account.settings.noRoles': '暂无角色',
  'pages.account.settings.permissions': '权限列表',
  'pages.account.settings.noPermissions': '暂无权限',
  'pages.account.settings.loginInfo': '登录信息',
  'pages.account.settings.lastLoginIp': '最后登录IP',
  'pages.account.settings.lastLoginTime': '最后登录时间',
  'pages.account.settings.passwordUpdateTime': '密码更新时间',
  'pages.account.settings.creator': '创建人',
  'pages.account.settings.system': '系统',
  'pages.account.settings.noUserInfo': '暂无用户信息',
  'pages.account.settings.username': '用户名',
  'pages.account.settings.normal': '正常',
  'pages.account.settings.disabled': '停用',
  'pages.account.settings.googleBindPassword': '修改密码需要绑定谷歌验证器',
  'pages.account.help.systemInfo': '系统信息',
  'pages.account.help.systemTime': '系统时间',
  'pages.account.help.systemVersion': '系统版本',
  'pages.account.help.systemTimeDescription':
    '本系统所有时间均以*UTC+0(协调世界时)*为标准,请根据您所在时区进行相应换算。',
  'pages.log.operate.title': '操作日志',
  'pages.log.operate.id': '日志编号',
  'pages.log.operate.systemModule': '系统模块',
  'pages.log.operate.operationType': '操作类型',
  'pages.log.operate.operationPerson': '操作人员',
  'pages.log.operate.operationAddress': '操作地址',
  'pages.log.operate.operationLocation': '操作地点',
  'pages.log.operate.operationStatus': '操作状态',
  'pages.log.operate.operationDate': '操作日期',
  'pages.log.operate.operationTime': '消耗时间',
  'pages.log.operate.details': '操作日志详情',
  'pages.log.operate.requestMethod': '请求方式',
  'pages.log.operate.requestParam': '请求参数',
  'pages.log.operate.responseResult': '返回参数',
  'pages.log.operate.loginInfo': '登录信息',
  'pages.log.operate.requestAddress': '请求地址',
  'pages.log.operate.operationMethod': '操作方法',
  'pages.log.login.title': '登录日志',
  'pages.log.login.infoId': '访问编号',
  'pages.log.login.userName': '用户名称',
  'pages.log.login.loginAddress': '登录地址',
  'pages.log.login.loginStatus': '登录状态',
  'pages.log.login.operationInfo': '操作信息',
  'pages.log.login.loginDate': '登录日期',
  'pages.bd.user.title': 'BD人员管理',
  'pages.bd.user.name': '姓名',
  'pages.bd.user.officialEmail': '官方邮箱',
  'pages.bd.user.bdType': 'BD类型',
  'pages.bd.user.teamSize': '团队人数',
  'pages.bd.user.socialMedia': '已验证链接',
  'pages.bd.user.socialMediaCount': '{count}个链接',
  'pages.bd.user.commission': '参与返佣',
  'pages.bd.user.addTime': '添加时间',
  'pages.bd.user.add': '升级合伙人',
  'pages.bd.user.edit': '编辑合伙人',
  'pages.bd.user.spotCommission': '现货返佣配置',
  'pages.bd.user.futuresCommission': '合约返佣配置',
  'pages.bd.user.commissionStrategy': '返佣策略',
  'pages.bd.user.loginEmail': '登录邮箱',
  'pages.bd.user.position': '职位',
  'pages.bd.user.bdCommission': 'BD返佣配置',
  'pages.bd.user.notificationLanguage': '通知语言',
  'pages.bd.user.emailRuleTip': '已取消 @bitbaby.com 后缀限制，支持通用邮箱',
  'pages.bd.user.setFuturesRebate': '设置合约级差返佣',
  'pages.bd.user.setSpotRebate': '设置现货比例返佣',
  'pages.bd.user.editSocialMedia': '编辑验证链接',
  'pages.futures.rebate.title': '合约返佣配置',
  'pages.futures.rebate.childName': '下级角色',
  'pages.futures.rebate.creator': '创建人',
  'pages.futures.rebate.rebateStrategy': '返佣策略',
  'pages.futures.rebate.splitType': '分成方式',
  'pages.futures.rebate.partner': '所含合伙人',
  'pages.futures.rebate.add': '添加返佣配置',
  'pages.futures.rebate.edit': '编辑返佣配置',
  'pages.futures.rebate.strategyName': '策略名称',
  'pages.futures.rebate.rebateScale': '返佣比例',
  'pages.futures.rebate.rebateLevel': '返佣级别',
  'pages.futures.rebate.addLevel': '添加级别',
  'pages.futures.rebate.deleteLevel': '删除级别',
  'pages.futures.rebate.maxLevels': '最多可添加10个级别',
  'pages.futures.rebate.agentDescription': '代理商可以获得下10级的返佣以及自返佣',
  'pages.futures.rebate.baseDescription': '普通用户直推比例设置',
  'pages.futures.rebate.baseDescriptionDescription': '说明：',
  'pages.futures.rebate.baseDescriptionDescription1': '1、用于设置本交易所普通用户推荐好友获得合约交易返佣的比例。',
  'pages.futures.rebate.baseDescriptionDescription2': '2、此金额由交易所额外支出，若配置0，则不支持普通用户返佣。',
  'pages.futures.rebate.myIdentityDescription': '我的身份：{name} 返佣比例：{returnScale}',
  'pages.futures.rebate.setCustomInviteCode': '设置自定义邀请码',
  'pages.futures.rebate.inviteCodeDescription':
    '邀请码内容必须符合所在国家/地区的法律法规，如有违规，平台将有权对其修改或实施账号封禁等惩罚措施。',
  'pages.futures.rebate.inviteCodeDescription1': '自定义邀请码为唯一值，不允许重复。',
  'pages.futures.rebate.inviteCodeDescription2': '自定义邀请码为4-10个字符限制，由字母和数字组成。',
  'pages.futures.rebate.inviteCodeDescription3':
    '自定义邀请码设置成功后，如已发布，建议不要轻易更换或删除，避免由于自定义邀请码失效，而导致邀请不成功的情况出现。',
  'page.futures.rebate.setCustomInviteCodePlaceholder': '请输入4-10个字符限制，包含大写字母、小写字母和数字任意两种',
  'pages.futures.rebate.inviteCodeTips': '注意事项：',
  'pages.futures.team.userName': '用户名称',
  'pages.futures.team.email': '邮箱',
  'pages.futures.team.identity': '身份认证',
  'pages.futures.team.partnerIdentity': '合伙人身份',
  'pages.futures.team.teamNum': '团队人数',
  'pages.futures.team.personalMonthVolume': '个人月交易量（折合USDT）',
  'pages.futures.team.teamMonthVolume': '团队月交易量（折合USDT）',
  'pages.futures.team.totalCommission': '累计贡献的佣金收益（折合USDT）',
  'pages.futures.team.viewInviteChain': '查看邀请链路',
  'pages.futures.team.searchUid': '请输入UID进行搜索',
  'pages.futures.team.basicInfo': '基本信息',
  'pages.futures.team.dataOverview': '数据总览',
  'pages.futures.team.accountOverview': '账户总览',
  'pages.futures.team.currency': '币种',
  'pages.futures.team.performanceOverview': '业绩概况',
  'pages.futures.team.superiorUid': '上级UID',
  'pages.futures.team.identityVerification': '身份认证',
  'pages.futures.team.partner': '合伙人',
  'pages.futures.team.commissionRatio': '返佣比例',
  'pages.futures.team.registerTime': '注册时间',
  'pages.futures.team.totalAssets': '总资产',
  'pages.futures.team.totalAssetsCurrency': '总资产(折合{currency})',
  'pages.futures.team.futuresAccountCurrency': '合约资产(折合{currency})',
  'pages.futures.team.spotAccountCurrency': '现货资产(折合{currency})',
  'pages.futures.team.futuresAccount': '合约账户',
  'pages.futures.team.netAssets': '净资产',
  'pages.futures.team.holdingAmount': '持仓量',
  'pages.futures.team.holdingAmountUSDT': '持仓量USDT',
  'pages.futures.team.holdingAmountUSDC': '持仓量USDC',
  'pages.futures.team.teamTotalNum': '团队总人数',
  'pages.futures.team.directInviteNum': '直推邀请人数',
  'pages.futures.team.kycVerifiedNum': 'KYC已认证人数',
  'pages.futures.team.transactionVolume': '交易量',
  'pages.futures.team.rechargeAmount': '充值量',
  'pages.futures.team.withdrawalAmount': '提现量',
  'pages.futures.team.commissionIncome': '返佣收益',
  'pages.futures.team.teamTransactionVolume': '团队交易量',
  'pages.futures.team.teamRechargeAmount': '团队充值量',
  'pages.futures.team.teamWithdrawalAmount': '团队提现量',
  'pages.futures.team.teamCommissionIncome': '团队返佣收益',
  'pages.futures.team.teamActiveNum': '团队活跃人数',
  'pages.futures.team.teamTransactionUserNum': '团队交易用户数',
  'pages.futures.team.teamFirstTradeUserNum': '团队首次交用户数',
  'pages.futures.team.teamFirstRechargeUserNum': '团队首次充值用户数',
  'pages.futures.team.teamActiveUserNumTips': '非实时数据统计，不包含当日数据',
  'pages.futures.team.selectDateRange': '请选择起止日期和时间',
  'pages.futures.team.all': '全部',
  'pages.futures.team.verified': '已认证',
  'pages.futures.team.unverified': '未认证',
  'pages.futures.team.phone': '手机号码',
  'pages.futures.team.isPartner': '是否为合伙人',
  'pages.futures.team.userList': '成员列表',
  'pages.futures.team.upgradePartner': '升级合伙人',
  'pages.futures.team.searchUidDescription': '输入UID搜索或等待数据加载',
  'pages.futures.team.upgradePartnerDescription': 'UID/邮箱/手机号',
  'pages.futures.team.theyAre': '分别为：',
  'pages.futures.team.myInviteCode': '我的邀请码：',
  'pages.futures.tradingVolume.teamTradingVolume': '团队交易量',
  'pages.futures.tradingVolume.transactionDate': '交易日期',
  'pages.futures.tradingVolume.inviterUID': '邀请人UID',
  'pages.futures.tradingVolume.commissionLevel': '返佣级别',
  'pages.futures.tradingVolume.currencyAmount': '币种数量',
  'pages.futures.tradingVolume.tradingVolume': '交易量（折合USDT）',
  'pages.futures.tradingVolume.tradingAmount': '交易金额',
  'pages.futures.tradingVolume.amountRange': '金额范围',
  'pages.futures.tradingVolume.theAbove': '{volume}USDT 以上',
  'pages.futures.teamCommission.title': '团队佣金',
  'pages.futures.teamCommission.titleList': '合约团队佣金',
  'pages.futures.teamCommission.statisticsTime': '统计时间',
  'pages.futures.teamCommission.settlementTime': '结算时间',
  'pages.futures.teamCommission.email': '邮箱',
  'pages.futures.teamCommission.phone': '手机号',
  'pages.futures.teamCommission.isPartner': '是否为合伙人',
  'pages.futures.teamCommission.partnerIdentity': '合伙人身份',
  'pages.futures.teamCommission.traderUID': '交易者UID',
  'pages.futures.teamCommission.rebateLevel': '返佣级别',
  'pages.futures.teamCommission.rebateScale': '返佣比例',
  'pages.futures.teamCommission.transactionType': '交易类型',
  'pages.futures.teamCommission.rebateFee': '手续费',
  'pages.futures.teamCommission.rebateAmount': '返佣金额（折合USDT）',
  'pages.futures.teamCommission.rebateStatus': '返佣状态',
  'pages.futures.teamCommission.tradingCurrency': '交易币种',
  'pages.futures.teamCommission.commissionTotal': '佣金总计(折合USDT)：{total} USDT',
  'pages.futures.teamCommission.commissionTotalTime': '最新返佣结算：{time}',
  'pages.futures.teamCommission.rebateNumber': '返佣数量（折合USDT）',
  'pages.futures.teamCommission.rebateNumberTitle': '返佣数量',
  'pages.futures.teamCommission.participateCurrency': '手续费币种',
  'pages.futures.teamCommission.rebateCurrency': '返佣币种',
  'pages.futures.subordinatePosition.currentPosition': '当前仓位',
  'pages.futures.subordinatePosition.historyPosition': '历史仓位',
  'pages.futures.subordinatePosition.openTime': '开仓时间',
  'pages.futures.subordinatePosition.openPrice': '开仓均价',
  'pages.futures.subordinatePosition.positionCount': '持仓量',
  'pages.futures.subordinatePosition.currentPrice': '当前价格',
  'pages.futures.subordinatePosition.currentPositionAverage': '当前仓位均价估值',
  'pages.futures.subordinatePosition.longShortRatio': '多空比概览',
  'pages.futures.subordinatePosition.closeTime': '平仓时间',
  'pages.futures.subordinatePosition.closePrice': '平仓均价',
  'pages.futures.subordinatePosition.fee': '手续费',
  'pages.futures.subordinatePosition.openAmount': '保证金',
  'pages.futures.commissionSummary.dateRange': '日期范围',
  'pages.futures.commissionSummary.tradeType': '交易类型',
  'pages.futures.commissionSummary.uid': 'UID',
  'pages.futures.commissionSummary.superiorUid': '上级UID',
  'pages.futures.commissionSummary.specifiedSubordinateUid': '下级团队UID',
  'pages.futures.commissionSummary.userType': '用户类型',
  'pages.futures.commissionSummary.all': '全部',
  'pages.futures.commissionSummary.directUser': '直推用户',
  'pages.futures.commissionSummary.directAgent': '直推代理',
  'pages.futures.commissionSummary.indirectUser': '间推用户',
  'pages.futures.commissionSummary.indirectAgent': '间推代理',
  'pages.futures.commissionSummary.self': '自己',
  'pages.futures.commissionSummary.pleaseSelect': '请选择',
  'pages.futures.commissionSummary.pleaseEnter': '请输入',
  'pages.futures.commissionSummary.date': '日期',
  'pages.futures.commissionSummary.commissionRecipientUid': '收佣方UID',
  'pages.futures.commissionSummary.titleList': '合约佣金汇总',
  'pages.futures.commissionSummary.cumulativeTradingVolume': '累计交易量',
  'pages.futures.commissionSummary.cumulativeFee': '累计手续费',
  'pages.futures.commissionSummary.cumulativeCommission': '累计返佣收益',
  'pages.futures.commissionSummary.dataNotice':
    '数据统计UTC+0早晨7点完成前一天的返佣计算和入库，可能存在短暂延迟。数据展示均折合USDT统计，待结算数据将不定期滚动更新（约每10分钟更新一次）。',
  'pages.futures.commissionDetails.dateRange': '日期范围',
  'pages.futures.commissionDetails.tradeType': '交易类型',
  'pages.futures.commissionDetails.uid': 'UID',
  'pages.futures.commissionDetails.superiorUid': '上级UID',
  'pages.futures.commissionDetails.traderUid': '交易者UID',
  'pages.futures.commissionDetails.specifiedSubordinateUid': '下级团队UID',
  'pages.futures.commissionDetails.userType': '用户类型',
  'pages.futures.commissionDetails.settlementStatus': '结算状态',
  'pages.futures.commissionDetails.all': '全部',
  'pages.futures.commissionDetails.self': '自己',
  'pages.futures.commissionDetails.directUser': '直推用户',
  'pages.futures.commissionDetails.directAgent': '直推代理用户',
  'pages.futures.commissionDetails.indirectUser': '间推用户',
  'pages.futures.commissionDetails.indirectAgent': '间推代理用户',
  'pages.futures.commissionDetails.pendingSettlement': '待结算',
  'pages.futures.commissionDetails.settled': '已结算',
  'pages.futures.commissionDetails.pleaseSelect': '请选择',
  'pages.futures.commissionDetails.pleaseEnter': '请输入',
  'pages.futures.commissionDetails.date': '日期',
  'pages.futures.commissionDetails.commissionRecipientUid': '收佣方UID',
  'pages.futures.commissionDetails.rebateProviderUid': '返佣方UID',
  'pages.futures.commissionDetails.tradingVolume': '交易量',
  'pages.futures.commissionDetails.tradingVolumeTooltip': '统计当天内返佣交易者用户产生的总交易量',
  'pages.futures.commissionDetails.fee': '手续费',
  'pages.futures.commissionDetails.originalFee': '原手续费',
  'pages.futures.commissionDetails.originalFeeTooltip': '统计当天内返佣交易者用户产生的总手续费',
  'pages.futures.commissionDetails.experienceFeeResistance': '体验金抵扣',
  'pages.futures.commissionDetails.experienceFeeResistanceTooltip':
    '用户使用体验金抵扣的部分不产生手续费收入,不计入返佣基数',
  'pages.futures.commissionDetails.futuresExperienceFeeResistance': '合约体验金抵扣',
  'pages.futures.commissionDetails.futuresExperienceFeeResistanceTooltip':
    '用户使用合约体验金抵扣的部分不产生手续费收入,不计入返佣基数',
  'pages.futures.commissionDetails.actualFee': '实付手续费',
  'pages.futures.commissionDetails.actualFeeTooltip': '实付手续费(返佣手续费)=原手续费-抵扣金额',
  'pages.futures.commissionDetails.rebateAmount': '返佣数量',
  'pages.futures.commissionDetails.cumulativeTradingVolume': '累计交易量',
  'pages.futures.commissionDetails.cumulativeFee': '累计手续费',
  'pages.futures.commissionDetails.cumulativeCommission': '累计返佣收益：{total} USDT',
  'pages.futures.commissionDetails.cumulativeTotalFee': '累计手续费：{total} USDT',
  'pages.futures.commissionDetails.cumulativeActualFee': '累计实付手续费：{total} USDT',
  'pages.futures.commissionDetails.dataNotice':
    '数据统计UTC+0早晨7点完成前一天的返佣计算和入库，可能存在短暂延迟。数据展示均折合USDT统计，待结算数据将不定期滚动更新（约每10分钟更新一次）。',
  'pages.futures.commissionDetails.pendingSettlementTitle': '待结算状态情况存在',
  'pages.futures.commissionDetails.pendingSettlementDesc1': 'BD不返佣时,状态就会是待结算。',
  'pages.futures.commissionDetails.pendingSettlementDesc2':
    'BD状态由不返佣改为返佣时,从修改的当天开始执行返佣计算。前一天结算任务已经跑了那么不会再进行结算。则从当天开始进行返佣结算转历史待结算不会进行结算。',
  'pages.futures.commissionDetails.bottomNotice': '统计不到交易时间,统计当天该交易',
  'pages.futures.commissionDetails.title': '合约佣金明细',
  'pages.spot.rebate.symbol': '参与币种',
  'pages.spot.rebate.all': '全部',
  'pages.spot.rebate.rebateSymbol': '返佣币种',
  'pages.spot.rebate.childRole': '下级角色',
  'pages.spot.rebate.rebateLevel': '返佣级别',
  'pages.spot.rebate.rebateScale': '返佣比例',
  'pages.spot.rebate.level': '层级',
  'pages.spot.team.spotAccount': '现货账户',
  'pages.spot.teamCommission.titleList': '现货团队佣金',
  'pages.rechargeRecord.title': '充值记录',
  'pages.rechargeRecord.rechargeUserUid': '充值用户UID',
  'recharge.user.uid': '充值用户UID',
  'pages.rechargeRecord.rechargeDate': '充值日期',
  'pages.rechargeRecord.fromUid': '转账用户UID',
  'pages.rechargeRecord.depositType': '充值类型',
  'pages.rechargeRecord.volume': '充值数量',
  'pages.rechargeRecord.amount': '充值金额（折合USDT）',
  'pages.rechargeRecord.symbol': '币种',
  'pages.rechargeRecord.pid': '邀请人UID',
  'pages.rechargeRecord.level': '返佣级别',
  'pages.rechargeRecord.totalRecharge': '总充值（折合USDT）',
  'pages.rechargeRecord.blockchainTransactionId': '区块链交易ID',
  'pages.withdrawRecord.title': '提现记录',
  'pages.withdrawRecord.withdrawDate': '提现日期',
  'pages.withdrawRecord.withdrawUserUid': '提现用户UID',
  'pages.withdrawRecord.withdrawType': '提现类型',
  'pages.withdrawRecord.reference': '转账用户UID/区块链交易ID/U卡卡号',
  'pages.withdrawRecord.referenceOnChain': '区块链交易ID',
  'pages.withdrawRecord.referenceInternal': '转账用户UID',
  'pages.withdrawRecord.referenceUCard': 'U卡卡号',
  'pages.withdrawRecord.symbol': '币种',
  'pages.withdrawRecord.pid': '邀请人UID',
  'pages.withdrawRecord.volume': '提现数量',
  'pages.withdrawRecord.amount': '提现金额（折合USDT）',
  'pages.withdrawRecord.totalWithdraw': '总提现（折合USDT）',
  'pages.withdrawRecord.toUid': '转账用户UID',
  'pages.transferRecord.title': '划转记录',
  'pages.transferRecord.transferDate': '划转日期',
  'pages.transferRecord.transferUserUid': '划转用户UID',
  'pages.transferRecord.fromAccount': '转出账户（from）',
  'pages.transferRecord.toAccount': '转入账户（to）',
  'pages.transferRecord.symbol': '币种',
  'pages.transferRecord.pid': '邀请人UID',
  'pages.transferRecord.volume': '划转数量',
  'pages.transferRecord.spotAccount': '现货账户',
  'pages.transferRecord.futuresAccount': '合约账户',
  'pages.activityData.search.registerDateRange': '注册日期',
  'pages.activityData.search.statDateRange': '统计日期',
  'pages.activityData.search.volumeQuery': '交易额',
  'pages.activityData.search.volumeQueryPlaceholder': '交易额',
  'pages.activityData.search.volumeQueryUnitMinute': '分钟',
  'pages.activityData.search.volumeQueryUnitHour': '小时',
  'pages.activityData.search.diffSeconds': '前后相差时间(秒)',
  'pages.activityData.search.orderOffsetPct': '订单成交金额相识度(%)',
  'pages.activityData.search.pleaseEnter': '请输入',
  'pages.activityData.table.uid': 'UID',
  'pages.activityData.table.isPartnership': '是否为合伙人',
  'pages.activityData.table.registerDate': '注册日期',
  'pages.activityData.table.inviterUid': '邀请人',
  'pages.activityData.table.futuresVolume': '合约交易额',
  'pages.activityData.table.spotVolume': '现货交易额',
  'pages.activityData.table.realizedProfit': '平仓盈亏',
  'pages.activityData.table.originalFee': '原始手续费',
  'pages.activityData.table.userFee': '实付手续费',
  'pages.activityData.table.depositUsdt': '充值USDT',
  'pages.activityData.table.withdrawUsdt': '提币USDT',
  'pages.activityData.table.netDepositUsdt': '净存USDT',
  'pages.activityData.table.ipUidList': 'IP/UID',
  'pages.activityData.table.deviceUidList': '设备ID/UID',
  'pages.activityData.table.hedgeAmount': '对冲成交金额',
  'pages.activityData.table.fiveMinVolume': '5分钟交易额',
  'pages.activityData.table.periodVolumeMinute': '{value}分钟交易额',
  'pages.activityData.table.periodVolumeHour': '{value}小时交易额',
  'pages.activityData.table.country': '国家',
  'pages.activityData.message.fetchFailed': '获取列表失败',
  'pages.activityData.unit.second': '秒',
  'pages.activityData.hedgeDetail.title': '对冲明细台账',
  'pages.activityData.hedgeDetail.searchUid': '检索UID',
  'pages.activityData.hedgeDetail.search.dealTimeRange': '成交时间',
  'pages.activityData.hedgeDetail.table.uid': 'UID',
  'pages.activityData.hedgeDetail.table.symbol': '交易对',
  'pages.activityData.hedgeDetail.table.tradeType': '交易类型',
  'pages.activityData.hedgeDetail.table.leverage': '杠杆',
  'pages.activityData.hedgeDetail.table.orderTime': '下单时间',
  'pages.activityData.hedgeDetail.table.orderPrice': '下单价格',
  'pages.activityData.hedgeDetail.table.orderVolume': '下单数量',
  'pages.activityData.hedgeDetail.table.orderAmount': '下单金额',
  'pages.activityData.hedgeDetail.table.dealTime': '成交时间',
  'pages.activityData.hedgeDetail.table.dealPrice': '成交价格',
  'pages.activityData.hedgeDetail.table.dealVolume': '成交数量',
  'pages.activityData.hedgeDetail.table.dealAmount': '成交金额',
  'pages.activityData.hedgeDetail.table.profitLoss': '盈亏',
  'pages.activityData.hedgeDetail.message.fetchFailed': '获取对冲明细失败',
  'pages.activityData.hedgeDetail.message.missingUidForExport': '缺少UID，无法导出',
  'pages.dashboard.futures.teamMemberCount': 'BD团队总人数',
  'pages.dashboard.futures.totalCommission': '佣金总发放量',
  'pages.dashboard.futures.teamTradingVolume': '团队总交易量',
  'pages.dashboard.futures.activePartner': '活跃合伙人统计',
  'pages.dashboard.futures.addPartner': '新增合伙人统计',
  'pages.dashboard.futures.performanceRank': '合伙人业绩排行榜',
  'pages.dashboard.futures.name': '姓名',
  'pages.dashboard.futures.count': '人数',
  'pages.dashboard.futures.viewDetail': '查看明细',
  'pages.dashboard.futures.commissionAmount': '佣金金额（折合USDT）',
  'pages.dashboard.futures.last3Months': '近三个月佣金发放量统计',
  'pages.dashboard.futures.month': '月份',
  'pages.dashboard.futures.last15DaysTeamTradingVolume': '近15天团队交易量统计',
  'pages.dashboard.futures.date': '日期',
  'pages.dashboard.futures.volume': '交易量（折合USDT）',
  'pages.dashboard.futures.number': '数量',
  'pages.dashboard.futures.last15DaysActivePartner': '近15天活跃合伙人统计',
  'pages.dashboard.futures.totalPartner': '合伙人总数',
  'pages.dashboard.futures.addPartnerNumber': '新增合伙人数量',
  'pages.dashboard.futures.last3MonthsAddPartner': '近3个月新增合伙人统计',
  'pages.dashboard.futures.ranking': '排名',
  'pages.dashboard.futures.partnerUid': '合伙人UID',
  'pages.dashboard.futures.commissionIncome': '佣金收入（USDT）',
  'pages.dashboard.futures.teamNum': '团队人数',
  'pages.dashboard.futures.commissionIncomeType': '佣金收入',
  'pages.dashboard.futures.teamTradingVolumeType': '团队交易量',
  'pages.dashboard.futures.addUserNumType': '新增用户数',
  'pages.dashboard.futures.yesterdayAddUserNum': '昨日新增用户数',
  'pages.dashboard.futures.directInviteNum': '直接邀请人数',
  'pages.dashboard.futures.indirectInviteNum': '间接邀请人数',
  'pages.dashboard.futures.yesterdayAddPersonNum': '昨日新增人数',
  'pages.dashboard.futures.lastAddRatio': '对比昨日新增比例',
  'pages.dashboard.futures.indirectTeamNum': '间接伞下团队人数',
  'pages.dashboard.futures.kycVerifiedNum': '已做身份认证人数',
  'pages.dashboard.futures.totalVolume': '总交易量',
  'pages.dashboard.futures.directVolume': '直接邀请月度交易量',
  'pages.dashboard.futures.indirectVolume': '间接伞下月度交易量',
  'pages.dashboard.futures.lastVolume': '昨日新增交易量',
  'pages.dashboard.futures.volumePercent': '对比昨日新增交易量',
  'pages.dashboard.futures.myProfits': '我的收益',
  'pages.dashboard.futures.totalTeamRebate': '我的佣金总收益',
  'pages.dashboard.futures.totalSubTeamRebate': '下级团队佣金收益',
  'pages.dashboard.futures.myProfitsChart': '佣金收益统计',
  'pages.dashboard.futures.myProfitsChartDescription': '我的佣金收益（折合USDT）',
  'pages.dashboard.futures.teamTradingVolumeChart': '团队交易总量统计',
  'pages.dashboard.futures.directInviteTradingVolume': '直接邀请交易量',
  'pages.dashboard.futures.subTeamTradingVolume': '下级团队交易总量',
  'pages.dashboard.futures.rechargeChart': '充值/人数',
  'pages.dashboard.futures.totalRechargeAmount': '总充值金额',
  'pages.dashboard.futures.totalRechargePeople': '总充值人数',
  'pages.dashboard.futures.rechargePeople': '充值人数',
  'pages.dashboard.futures.rechargeAmount': '充值金额',
  'pages.dashboard.futures.rechargeAmountAndPeopleStat': '充值金额&人数统计',
  'pages.dashboard.futures.promotion': '推广',
  'pages.dashboard.futures.latestUpdateTime': '数据更新时间',
  'pages.dashboard.futures.dataOverview': '数据概览',
  'pages.dashboard.futures.mySubordinates': '我的下级',
  'pages.dashboard.futures.subordinateCount': '下级人数',
  'pages.dashboard.futures.spot': '现货',
  'pages.dashboard.futures.futures': '合约',
  'pages.dashboard.overview.myCommission': '我的佣金',
  'pages.dashboard.overview.myCommissionTooltip':
    '展示自身当前返佣明细数据，当前返佣账户总额 = 已结算返佣 + 待结算返佣(待结算返佣会在 T+1 6点结算)',
  'pages.dashboard.overview.inviteCode': '邀请码',
  'pages.dashboard.overview.customize': '自定义',
  'pages.dashboard.overview.copyInviteCode': '复制邀请码',
  'pages.dashboard.overview.copyInviteLink': '复制邀请链接',
  'pages.dashboard.overview.mySubordinates': '我的下级',
  'pages.dashboard.overview.mySubordinatesTooltip':
    '展示当前登录用户所有直接和间推伞下的返佣收益数据和下级链路总人数。',
  'pages.dashboard.overview.subordinateCount': '下级人数',
  'pages.dashboard.overview.person': '人',
  'pages.dashboard.recentResults.title': '近期业绩',
  'pages.dashboard.recentResults.tooltip':
    '根据所选时间范围和UID，展示自身及下级用户的所有交易数据，数据展示存在正常延时。',
  'pages.dashboard.recentResults.uidPlaceholder': '请输入下级团队UID',
  'pages.dashboard.recentResults.search': '查询',
  'pages.dashboard.recentResults.reset': '重置',
  'pages.dashboard.recentResults.commission': '返佣金额',
  'pages.dashboard.recentResults.fee': '手续费',
  'pages.dashboard.recentResults.volume': '交易量',
  'pages.dashboard.recentResults.depositAmount': '入金金额',
  'pages.dashboard.recentResults.traderCount': '交易人数',
  'pages.dashboard.recentResults.teamNewCount': '团队新增人数',
  'pages.dashboard.recentResults.chartDescription': '数据与近期业绩联动,按时间筛选显示趋势图并折合USDT统计。',
  'pages.dashboard.chartArea.commission': '返佣金额',
  'pages.dashboard.chartArea.fee': '手续费',
  'pages.dashboard.chartArea.volume': '交易量',
  'pages.dashboard.chartArea.depositAmount': '入金金额',
  'pages.dashboard.chartArea.traderCount': '交易人数',
  'pages.dashboard.chartArea.teamNewCount': '团队新增人数',
  'pages.dashboard.chartArea.futures': '合约',
  'pages.dashboard.chartArea.spot': '现货',
  'pages.dashboard.chartArea.total': '总计',
  'pages.dashboard.chartArea.dropdownArrow': '下拉箭头',
  'pages.dashboard.chartPie.futures': '合约',
  'pages.dashboard.chartPie.spot': '现货',
  'pages.dashboard.chartPie.total': '总计',
  'pages.dashboard.chartPie.type': '类型',
  'pages.dashboard.chartPie.percentage': '百分比',
  'pages.dashboard.chartPie.quantity': '数量',
  'pages.dashboard.chartPie.unit': '单位:USDT',
  'pages.dashboard.chartPie.chartTitle': '合约和现货占比图表',
  'pages.dashboard.dailyResults.title': '每日业绩',
  'pages.dashboard.dailyResults.date': '日期',
  'pages.dashboard.dailyResults.commission': '返佣金额',
  'pages.dashboard.dailyResults.commissionTooltip': '返佣金额包含多个币种，按汇率折算成USDT展示',
  'pages.dashboard.dailyResults.volume': '交易量',
  'pages.dashboard.dailyResults.volumeTooltip': '交易量包含多个币种，按汇率折算成USDT展示',
  'pages.dashboard.dailyResults.traderCount': '交易人数',
  'pages.dashboard.dailyResults.traderCountTooltip':
    '统计筛选的时间的每日有过交易的人数(去重)，同一自然日去重，跨日可重复计数，非标准人次',
  'pages.dashboard.dailyResults.teamNewCount': '团队新增人数',
  'pages.dashboard.dailyResults.teamNewCountTooltip': '下级代理邀请成功的注册人数，按天数汇总',
  'pages.dashboard.dailyResults.fee': '手续费',
  'pages.dashboard.dailyResults.feeTooltip': '手续费包含多个币种，按汇率折算成USDT展示',
  'pages.dashboard.dailyResults.depositCount': '入金人数',
  'pages.dashboard.dailyResults.depositCountTooltip': '每日各下级代理入金人数统计，重复入金仅记1人',
  'pages.dashboard.dailyResults.depositAmount': '入金金额',
  'pages.dashboard.dailyResults.depositAmountTooltip': '包括链上充值及站内直转金额，按天数汇总',
  'pages.dashboard.dailyResults.withdrawCount': '出金人数',
  'pages.dashboard.dailyResults.withdrawCountTooltip': '每日各下级代理出金人数统计',
  'pages.dashboard.dailyResults.withdrawAmount': '出金金额',
  'pages.dashboard.dailyResults.withdrawAmountTooltip': '包括链上提现及U卡提币，折合USDT',
  'pages.dashboard.dailyResults.futures': '合约：',
  'pages.dashboard.dailyResults.spot': '现货：',
  'pages.dashboard.recentPerformanceVolume.depositAmount': '入金金额',
  'pages.dashboard.recentPerformanceVolume.depositAmountTooltip': '统计链上充值、信用卡买币及站内转账',
  'pages.dashboard.recentPerformanceVolume.withdrawAmount': '出金金额',
  'pages.dashboard.recentPerformanceVolume.withdrawAmountTooltip': '统计链上提现、U卡提现及站内转账',
  'pages.dashboard.recentPerformanceVolume.teamProfitLoss': '团队盈亏',
  'pages.dashboard.recentPerformanceVolume.teamProfitLossTooltip': '统计伞下所有用户的已实现盈亏',
  'pages.dashboard.recentPerformanceVolume.traderCount': '交易人数',
  'pages.dashboard.recentPerformanceVolume.traderCountTooltip': '统计伞下所有用户的现货和合约交易人数',
  'pages.dashboard.recentPerformanceVolume.teamNewCount': '团队新增人数',
  'pages.dashboard.recentPerformanceVolume.teamNewCountTooltip': '统计伞下全链路新增的注册用户数',
  'pages.team.title': '团队管理',
  'pages.team.keywordSearch': '关键词搜索',
  'pages.team.searchPlaceholderUid': '请输入UID',
  'pages.team.searchPlaceholderEmail': '请输入邮箱',
  'pages.team.searchPlaceholderPhone': '请输入手机号',
  'pages.team.futuresRebate': '合约返佣',
  'pages.team.spotRebate': '现货返佣',
  'pages.team.totalAssetValuationUsdt': '总资产估值（折合USDT）',
  'pages.team.spotAccountValuationUsdt': '现货账户估值（折合USDT）',
  'pages.team.futuresAccountValuationUsdt': '合约账户估值（折合USDT）',
  'pages.team.transactionTime': '交易时间',
  'pages.team.personalMonthVolume': '现货个人累计交易量（折合USDT）',
  'pages.team.futuresPersonalMonthVolume': '合约个人累计交易量（折合USDT）',
  'pages.team.spotTeamMonthVolume': '现货团队累计交易量（折合USDT）',
  'pages.team.futuresTeamMonthVolume': '合约团队累计交易量（折合USDT）',
  'pages.team.spotTotalCommissionProfit': '现货佣金收益（折合USDT）',
  'pages.team.futuresTotalCommissionProfit': '合约佣金收益（折合USDT）',
  'pages.team.futuresLevelDifferenceRebate': '合约级差返佣',
  'pages.team.spotProportionRebate': '现货比例返佣',
  'pages.team.notificationEmailLanguage': '通知语言',
  'pages.team.languageEnglish': '英语',
  'pages.team.languageChinese': '简体中文',
  'pages.team.setSpotRebate': '设置现货返佣',
  'pages.team.yourSpotRebate': '您的现货返佣：{spotScalesStr}（请设置的层级相加不能大于自身第一层级比例）',
  'pages.team.setFuturesRebate': '设置合约返佣',
  'pages.team.yourFuturesRebate': '您的合约返佣：{futuresFriendScaleStr}（请设置小于自身的级差返佣比例）',
  'pages.team.supportSelfRebate': '是否支持自返佣',
  'pages.team.futuresSelfRebateRatio': '合约自返佣比例',
  'pages.team.spotSelfRebateRatio': '现货自返佣比例',
  'pages.team.selfRebateRatio': '自返佣比例',
  'pages.team.futuresRebateRatio': '合约返佣比例',
  'pages.team.rebateZeroWarning':
    '编辑合约返佣收益比例为0%，会影响该用户的直推和间推用户的返佣收益比例为0%，请谨慎操作。请问是否继续设置为0%？',
  'pages.team.rebateZeroWarningTip': '编辑提示',
  'pages.team.rebateDecreaseWarning':
    '编辑合约返佣比例下降，会影响该用户的直推和间推用户的返佣同比例下降，请谨慎操作~。请问是否继续设置下降？',
  'pages.team.rebateDecreaseWarningTip': '编辑提示',
  'pages.team.rebateDecreaseError': '您仅可上调或维持当前返佣比例。如需下调，请联系平台运营人员进行申诉。',
  'pages.team.spotRebateTip': '运营后台特别配置，无法编辑，如有需要可联系相关运营人员操作。',
  'pages.invitationLink.title': '链路管理',
  'pages.invitationLink.add': '新增链接',
  'pages.invitationLink.futuresSelfScale': '返佣比例（我）',
  'pages.invitationLink.futuresScale': '返佣比例（好友）',
  'pages.invitationLink.registerNum': '注册人数',
  'pages.invitationLink.status': '链路状态',
  'pages.invitationLink.my': '我的',
  'pages.invitationLink.friend': '好友',
  'pages.invitationLink.myIdentityDescription': '我的返佣比例：合约级差{futuresScale} 现货返佣比例：{spotScale}',
  'pages.tradingVolume.futuresTradingVolume': '合约交易量',
  'pages.tradingVolume.spotTradingVolume': '现货交易量',
  'pages.tradingVolume.spotTradingFee': '现货手续费',
  'pages.tradingVolume.futuresTradingFee': '合约手续费',
  'pages.tradingVolume.futuresTradingVolumeUsdt': '合约交易量（折合USDT）',
  'pages.tradingVolume.futuresTradingFeeUsdt': '合约手续费（折合USDT）',
  'pages.tradingVolume.spotTradingVolumeUsdt': '现货交易量（折合USDT）',
  'pages.tradingVolume.spotTradingFeeUsdt': '现货手续费（折合USDT）',
  'pages.tradingVolume.spotTradingFeeTip': '该手续费为交易原始手续费，未减去抵扣数量',
};
